var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      staticClass: "group-card",
      attrs: { to: { name: "group", params: { id: _vm.data.id } } },
    },
    [
      _c("ImgComponent", { attrs: { head_img: _vm.data.img } }),
      _c(
        "div",
        { staticClass: "group-card__text" },
        [
          _c("h4", { staticClass: "group-card__title" }, [
            _vm._v(_vm._s(_vm.data.title)),
          ]),
          _c(
            "router-link",
            { staticClass: "group-card__route", attrs: { to: { name: "" } } },
            [
              _vm._v("Подробнее\n      "),
              _c("IconComponent", { attrs: { name: "arrow-right" } }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }